import ko from "knockout";
import _ from "lodash";
import ObservableModel from "util/ObservableModel";
import VisibilityCondition from "models/composer/VisibilityCondition";

export default ObservableModel.extend(
    {
        defaults: {
            type: "",
            text: "",
            helpText: "",
            naEnabled: false,
            naSelected: false,
            answer: "",
            comments: "",
            commentsRequired: false,
            isCritical: false,
            isKill: false,
        },
        modelProperties: {
            visibilityCondition: VisibilityCondition,
        },
    },
    function baseQuestionModel_init() {
        const self = this;

        self.modelId = _.uniqueId("question");
        let hasFakeId = false;
        if (!self.id) {
            self.id = self.modelId;
            hasFakeId = true;
        }

        self.index = ko.observable(-1);
        self.questionGroupIndex = ko.observable(-1);

        if (!self.visibilityCondition) {
            self.visibilityCondition = ko.observable(null);
        }

        self.visibilityCondition.extend({
            validation: {
                validator: function (val) {
                    return !val || val.isValid();
                },
            },
        });

        self.addVisibilityCondition = function () {
            self.visibilityCondition(new VisibilityCondition());
        };

        // Add Knockout-Validation functionality.
        self.maxTextLength = ko.observable();
        self.text.extend({
            trimmed: null,
            required: true,
            localizedValidator: {
                maxLength: {
                    value: self.maxTextLength,
                    messageKey: "composer.surveys.editor.question.textTooLong",
                    messageParams: {
                        maxLength: self.maxTextLength,
                    },
                    onlyIf: function () {
                        return self.maxTextLength() > 0;
                    },
                },
            },
        });

        self.maxHelpTextLength = ko.observable();
        self.helpText.extend({
            localizedValidator: {
                maxLength: {
                    value: self.maxHelpTextLength,
                    messageKey:
                        "composer.surveys.editor.question.helpTextTooLong",
                    messageParams: {
                        maxLength: self.maxHelpTextLength,
                    },
                    onlyIf: function () {
                        return self.maxHelpTextLength() > 0;
                    },
                },
            },
        });

        ko.validation.group(self, { deep: true, live: true });
        self.errors.showAllMessages(true);

        // Add an unwrap function to remove all unnecessary properties.
        // toIgnore - {object} OR {array}
        //   {object} - An object that maps which properties to ignore based on the type of the model.
        //     The toIgnore key pertaining to this model would be;
        //       'baseQuestion': ['properties', 'to', 'ignore']
        //   OR {array} an array of properties to ignore:
        //       ['properties', 'to', 'ignore']
        self.baseUnwrap = function (toIgnore, options) {
            toIgnore = toIgnore || {};
            options = options || {};
            const typeName = "baseQuestion";
            let ignore = [
                "errors",
                "isAnyMessageShown",
                "isValid",
                "modelId",
                "unwrap",
                "baseUnwrap",
                "constructor",
                "visibilityCondition",
                "addVisibilityCondition",
                "index",
                "questionGroupIndex",
            ];
            if (options.ignoreFakeIds && hasFakeId) {
                ignore.push("id");
            }
            let passToKids = false;
            if (toIgnore instanceof Array) {
                // if toIgnore is an array
                ignore = ignore.concat(toIgnore || []);
            } else {
                // if toIgnore is an object mapping
                ignore = ignore.concat(toIgnore[typeName] || []);
                passToKids = true;
            }
            const data = ObservableModel.unwrap(self, ignore);
            if (
                self.visibilityCondition &&
                self.visibilityCondition() &&
                !options.removeVisibilityCondition
            ) {
                data.visibilityCondition = self
                    .visibilityCondition()
                    .unwrap(passToKids ? toIgnore : undefined, options);
            }
            return data;
        };

        //Can be overwritten by extending classes, like MulitpleChoiceQuestion
        self.unwrap = self.baseUnwrap;
    }
);
